import React, { useEffect, useState } from 'react'
import { Alert } from '@material-ui/lab'
import AllStatesSearchResultCard from './AllStatesSearchResultCard'

const AllStatesCurrentSearch = (props) => {

    const { viewResult, currentSearch, search, applicantId } = props
    const searchId = currentSearch?.searchId
    
    const [searchResult, setSearchResult] = useState(false)
    const [alertProp, setAlertProp] = useState({ msg: 'Search completed successfully', severity: 'success' })

    useEffect(() => {
        handleResponseFinished(currentSearch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleResponseFinished = (res) => {
        if (res && res.results && res.results.length > 0) {
            setSearchResult(res.results[0])
            return;
        }

        if (res && res.results && res.results.length === 0) {
            setAlertProp({ msg: 'No results found for your search', severity: 'warning' })
        } else if (res && res.error) {
            setAlertProp({ msg: 'Search failed. Please try again.', severity: 'error' })
        }
    }

    return (
        <div className='mt-5'>
            {
                searchResult ?
                    <AllStatesSearchResultCard
                        searchResult={{ ...searchResult, searchId }}
                        viewResult={viewResult}
                        applicantId={applicantId}
                    />
                    :
                    <Alert severity={alertProp.severity}> {alertProp.msg} </Alert>
            }
        </div>
    )
}

export default AllStatesCurrentSearch